import API from "../../../app/api";

// =========================================================
// ORDER LIST
// =========================================================
export const getOrders = async (params = {}) => {
  try {
    const response = await API.get("/orders", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error(
      "Get Orders Error:",
      error?.response?.data || error
    );

    throw error;
  }
};

// =========================================================
// SINGLE ORDER DETAILS
// =========================================================
export const getOrderDetails = async (orderNo) => {
  try {
    const response = await API.get(
      `/orders/${encodeURIComponent(orderNo)}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Get Order Details Error:",
      error?.response?.data || error
    );

    throw error;
  }
};

// =========================================================
// SEND WHATSAPP NOTIFICATION
// =========================================================
export const sendOrderWhatsapp = async ({
  order,
  mobile,
  message,
}) => {
  try {
    let cleanMobile = String(
      mobile || ""
    ).replace(/\D/g, "");

    // Remove 91 country code
    if (
      cleanMobile.startsWith("91") &&
      cleanMobile.length === 12
    ) {
      cleanMobile = cleanMobile.substring(2);
    }

    const orderToken =
      order?.order_token ||
      order?.token ||
      "";

    const orderNo =
      order?.order_no ||
      order?.order_number ||
      "";

    const customerName =
      order?.customer_name ||
      order?.customer?.name ||
      order?.customer?.customer_name ||
      "";

    const customerId =
      order?.customer_id ||
      order?.customer?.id ||
      null;

    // =====================================================
    // ORDER URL
    // =====================================================
    const orderUrl =
      order?.order_url ||
      `https://b2b.obsessionsindia.in/ref/${orderToken}`;

    if (!orderToken) {
      throw new Error(
        "Order token is missing"
      );
    }

    if (!cleanMobile) {
      throw new Error(
        "Mobile number is missing"
      );
    }

    // =====================================================
    // PAYLOAD
    // =====================================================
    const payload = {
      order_token: orderToken,
      order_no: orderNo,
      order_url: orderUrl,
      customer_id: customerId,
      customer_name: customerName,
      mobile: cleanMobile,
      message: message || "",
    };

    const response = await API.post(
      "/notifications/whatsapp",
      payload
    );

    return response.data;

  } catch (error) {
    console.error(
      "WhatsApp Notification Error:",
      error?.response?.data || error
    );

    throw error;
  }
};

/**
 * 
 * @param {*} invoiceNo 
 * @returns 
 */

export const getInvoice = async (invoiceNo) => {

   try {
    const response = await API.get(
      `/invoices/${encodeURIComponent(invoiceNo)}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get invoiceNo Details Error:",
      error?.response?.data || error
    );

    throw error;
  }
 
};